import dayjs from 'dayjs';
import { TABS } from './constants';

export const capitalize = (string) =>
    string && string[0].toUpperCase() + string.slice(1);

export const uniqueArrayById = (array) => {
    // Create an object to store unique IDs
    const uniqueIds = {};

    // Use reduce to iterate through the array and build the unique array
    const uniqueArray = array.reduce((acc, obj) => {
        // Check if the ID already exists in the uniqueIds object
        if (!uniqueIds[obj.id]) {
            // If it doesn't exist, add it to the uniqueIds object and push the object to the accumulator
            uniqueIds[obj.id] = true;
            acc.push(obj);
        }
        return acc;
    }, []);

    return uniqueArray;
};

export const disabledDate = (current) => {
    return current && current <= dayjs();
};

export const getCardBGColor = (start, MFB) => {
    const startTime=dayjs(start);
    const timeToCheck = dayjs(MFB);
    const referenceTime = timeToCheck.set('hour', 15).set('minute', 0);
    const isToday = timeToCheck.isSame(startTime, 'day');

    if (isToday) {
        if (
            timeToCheck.isBefore(referenceTime) ||
            timeToCheck.isSame(referenceTime)
        ) {
            return 'lightpink';
        } else {
            return 'lightyellow';
        }
    }

    return 'white';
};


export const filterTasksByTab = (tasks = [], selectedTab) => {
    const listingCodes = TABS[selectedTab] || [];
    return tasks.filter((task) => {
        const [hotelCode] = task.listing?.nickname.split(' ') || [];
        return listingCodes.includes(hotelCode);
    });
};


export const sortTasks = (tasks) => {
    return [...tasks].sort((a, b) => {
        const [aTitle, bTitle] = [a.title, b.title];
        const [isANumbered, isBNumbered] = [
            /^\d+/.test(aTitle),
            /^\d+/.test(bTitle),
        ];

        if (!isANumbered || !isBNumbered) return isANumbered ? 1 : -1;

        return isANumbered && isBNumbered
            ? +aTitle.split(':')[0] - +bTitle.split(':')[0]
            : aTitle.localeCompare(bTitle);
    });
};

export const isMainCleaning = (taskTitle) =>
    /^\d*:\s*?Cleaning\b|^Cleaning\b/.test(taskTitle);
